export const PREFERRED_COUNTRY = {
	cookieName: 'preferredCountry',
	path: '/',
	expiration: 365
};

export const PREFERRED_LANGUAGE = {
	cookieName: 'preferredLanguage',
	path: '/',
	expiration: 365
};